import { render } from "./MentorTaskManage.vue?vue&type=template&id=59d4d2b2&scoped=true"
import script from "./MentorTaskManage.vue?vue&type=script&lang=js"
export * from "./MentorTaskManage.vue?vue&type=script&lang=js"

import "./MentorTaskManage.vue?vue&type=style&index=0&id=59d4d2b2&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d4d2b2"]])

export default __exports__